import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

type LeadCaptureType = 'diy' | 'strategic-services' | 'full-service'
type LeadCaptureView = 'initial' | 'contact-form' | 'success'

interface LeadCaptureState {
  currentView: LeadCaptureView
  leadCaptureType: LeadCaptureType | null
  setView: (view: LeadCaptureView) => void
  setLeadCaptureType: (type: LeadCaptureType) => void
  resetState: () => void
  isLoading: boolean
  setIsLoading: (isLoading: boolean) => void
  isModalOpen: boolean
  setIsModalOpen: (isModalOpen: boolean) => void
}

export const useLeadCaptureStore = create<LeadCaptureState>()(
  subscribeWithSelector((set) => ({
    currentView: 'initial',
    leadCaptureType: null,
    isLoading: false,
    setView: (view) => set({ currentView: view }),
    setLeadCaptureType: (type) => set({ leadCaptureType: type }),
    resetState: () => set({ currentView: 'initial', leadCaptureType: null }),
    setIsLoading: (isLoading) => set({ isLoading }),
    isModalOpen: false,
    setIsModalOpen: (isModalOpen) => set({ isModalOpen }),
  })),
)
